var React = require('react');

function Close (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("path",{"id":"x","d":"M28 24V10a2 2 0 1 0-4 0v14H10a2 2 0 1 0 0 4h14v14a2 2 0 1 0 4 0V28h14a2 2 0 1 0 0-4H28z"})),React.createElement("use",{"transform":"rotate(45 28.828 19.172)","xlinkHref":"#x","key":1})]);
}

Close.defaultProps = {"width":"44","height":"44","viewBox":"0 0 44 44"};

module.exports = Close;

Close.default = Close;
